<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="surrForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.wiringType }}</v-subheader>
              <div class="queryValue" v-for="item in filterWiringTypeList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="wiringTypeList"
                v-model="lightForm.wiringType"
                :label="labels.wiringType"
                item-text="label"
                item-value="value"
                data-vv-name="lightForm.wiringType"
                :data-vv-as="labels.wiringType"
                :error-messages="errors.collect('lightForm.wiringType')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md3 lg3 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.cbType }}</v-subheader>
              <div class="queryValue" v-for="item in filterCbTypeList" :key="item.label">{{ item.label }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-autocomplete
                :items="cbTypeList"
                v-model="lightForm.cbType"
                :label="labels.cbType"
                item-text="label"
                item-value="value"
                data-vv-name="lightForm.cbType"
                :data-vv-as="labels.cbType"
                :error-messages="errors.collect('lightForm.cbType')"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.noGen }}</v-subheader>
              <div class="queryValue">{{ lightForm.noGen }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.noGen"
                v-model="lightForm.noGen"
                :error-messages="errors.collect('lightForm.noGen')"
                data-vv-name="lightForm.noGen"
                :data-vv-as="labels.noGen"
                v-validate="'entry|numeric'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.ltgRemarks }}</v-subheader>
              <div class="queryValue">{{ lightForm.ltgRemarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="lightForm.ltgRemarks"
                :label="labels.ltgRemarks"
                :error-messages="errors.collect('surrForm.ltgRemarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="lightForm.ltgRemarks"
                :data-vv-as="lightForm.ltgRemarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { wiringTypeList, cbTypeList } from './index'

export default {
  data() {
    return {
      labels: {
        wiringType: 'Wiring',
        cbType: 'Circuit Breaker',
        noGen: 'No. of Standby Generators',
        ltgRemarks: 'Lighting Comments'
      },
      lightForm: {
        survNo: undefined,
        verCnt: undefined,
        wiringType: undefined,
        cbType: undefined,
        noGen: 0,
        ltgRemarks: undefined,
        survDetType: 'lighting'
      },
      tabNav: 0,
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      loading: false,
      showErrorDialog: false,
      submitting: false,
      wiringTypeList: [],
      cbTypeList: []
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    },
    filterWiringTypeList() {
      return this.wiringTypeList.filter((list) => {
        return list.value === parseInt(this.lightForm.wiringType)
      })
    },
    filterCbTypeList() {
      return this.cbTypeList.filter((list) => {
        return list.value === parseInt(this.lightForm.cbType)
      })
    }
  },
  methods: {
    async doInit() {
      this.lightForm.survNo = this.riskSurveyMaster.survNo
      this.lightForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    async loadInit() {
      this.lightForm.wiringType = parseInt(this.riskSurveyDetails.wiringType)
      this.lightForm.cbType = parseInt(this.riskSurveyDetails.cbType)
      this.lightForm.noGen = this.riskSurveyDetails.noGen
      this.lightForm.ltgRemarks = this.riskSurveyDetails.ltgRemarks
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doReset() {
      this.lightForm.wiringType = undefined
      this.lightForm.cbType = undefined
      this.lightForm.noGen = 0
      this.lightForm.ltgRemarks = undefined
    }
  },
  created() {
    this.wiringTypeList = wiringTypeList
    this.cbTypeList = cbTypeList
  },
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {}
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
